import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const OpticalDrive = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M8.001 1.322a7.664 7.664 0 1 1-.737 15.294A7.667 7.667 0 0 1 5.017 1.925c.944-.4 1.96-.605 2.984-.603Zm0 14.666a7.002 7.002 0 0 0 2.725-13.45 7.002 7.002 0 0 0-5.45 12.9 6.958 6.958 0 0 0 2.725.55Z" />
      <path d="M2.836 7.989a.333.333 0 0 1-.323-.42A5.77 5.77 0 0 1 6.583 3.5a.333.333 0 1 1 .172.644 5.1 5.1 0 0 0-3.597 3.598.333.333 0 0 1-.322.247ZM8.001 6.656a2.333 2.333 0 1 1 0 4.667 2.333 2.333 0 0 1 0-4.667Zm0 4a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z" />
    </svg>
  );
};

OpticalDrive.category = 'product-category';

OpticalDrive.displayName = 'OpticalDrive';
